export default function simplePluralize(
  count: number,
  wordSingular: string,
  wordPlural: string,
  includeCount = true
): string {
  const wordPluralized = `${count === 1 ? wordSingular : wordPlural}`;
  if (includeCount) {
    return `${count} ${wordPluralized}`;
  }
  return wordPluralized;
}
